import axiosInstance from '../axiosInceptor';

const baseUrl = () => process.env.REACT_APP_PROXY_BASE_URL || '';

/** Coalesce concurrent GETs for the same user (login + profile + multiple dispatches). */
const inflightByUserId = new Map<
  string,
  Promise<{ has_seen_phone_prompt?: boolean }>
>();

/** GET phone-prompt?userId= — reads whether the user has seen the phone prompt for this environment. */
export async function fetchPhonePrompt(
  userId: string,
): Promise<{ has_seen_phone_prompt?: boolean }> {
  const existing = inflightByUserId.get(userId);
  if (existing) return existing;
  const p = (async () => {
    const res = await axiosInstance.get(
      `${baseUrl()}/user/phone-prompt?userId=${encodeURIComponent(userId)}`,
    );
    const payload = res.data?.data ?? res.data;
    return typeof payload === 'object' && payload !== null ? payload : {};
  })().finally(() => {
    inflightByUserId.delete(userId);
  });
  inflightByUserId.set(userId, p);
  return p;
}

/** POST — Worker binds `body.user_id`; Joi should allow `user_id` (and optionally `userId`). */
export async function setPhonePromptPreference(
  userId: string,
  has_seen_phone_prompt: boolean,
): Promise<void> {
  await axiosInstance.post(`${baseUrl()}/user/phone-prompt`, {
    user_id: userId,
    has_seen_phone_prompt,
  });
}
